
print('start')

for i = 1, 5 do
  print('Hello world', i)
end

print('end')
